import ga from "./ga";
import pixel from "./pixel";
import { ProductState } from "../store/chart";

const { dataLayer, genomeTP } = window;

export const trackChartLoad = () => {
  try {
    ga.onChartLoad(dataLayer);
    pixel.onChartLoad(genomeTP);
  } catch (error) {
    console.error("Error emitting analytic event", error);
  }
};

export const trackTableVisible = (products: ProductState[]) => {
  try {
    ga.onTableVisible(dataLayer, products);
  } catch (error) {
    console.error("Error emitting analytic event", error);
  }
};

export const trackShowOnlyDifferencesToggle = (toggleStatus = false) => {
  try {
    ga.onShowOnlyDifferencesToggle(dataLayer, toggleStatus);
  } catch (error) {
    console.error("Error emitting analytic event", error);
  }
};

export const trackProductSelect = (product: ProductState) => {
  try {
    ga.onProductSelect(dataLayer, product);
    pixel.onProductSelect(genomeTP, product);
  } catch (error) {
    console.error("Error emitting analytic event", error);
  }
};

export const trackProductUnselect = (product: ProductState) => {
  try {
    ga.onProductUnselect(dataLayer, product);
    pixel.onProductUnselect(genomeTP, product);
  } catch (error) {
    console.error("Error emitting analytic event", error);
  }
};

export const trackShopClick = (product: ProductState) => {
  try {
    ga.onShopClick(dataLayer, product);
    pixel.onShopClick(genomeTP, product);
  } catch (error) {
    console.error("Error emitting analytic event", error);
  }
};

export const trackShopSelectClick = (product: ProductState) => {
  try {
    ga.onProductUnselect(dataLayer, product);
    pixel.onShopSelectClick(genomeTP, product);
  } catch (error) {
    console.error("Error emitting analytic event", error);
  }
};
